import global from '@helpers/global';
import { Device, until } from '@helpers/media';
import debounce from 'lodash/debounce';
import React, { useState } from 'react';
import useMedia from './useMedia';

const useMobileNavOffset = (): number => {
  const isMobile = useMedia([until(Device.TabletLarge)], [true], false);
  const [topOffset, setTopOffset] = useState<number>(global.navHeight);

  React.useEffect(() => {
    if (isMobile) {
      setTopOffset(global.navHeightSmall);
    }
  }, [isMobile]);

  const determineTopOffset = (): void => {
    const offset = Math.max(global.navHeightSmall - window.scrollY, 0);
    setTopOffset(offset);
  };

  const debouncedTopOffset = debounce(determineTopOffset, 1000 / 60);

  React.useEffect(() => {
    window.addEventListener('scroll', debouncedTopOffset);
  }, []);

  return topOffset;
};

export default useMobileNavOffset;
